import RichTextView from 'components/modules/RichTextView';

import QuestionnaireMetaInfo from './QuestionnaireMetaInfo';
import QuestionResults from './QuestionResults';


const ListView = ({
    onClickAnswerDetail,
    questionnaire,
    onAnimationEnd
}: {
    onClickAnswerDetail: (item: Question) => void;
    questionnaire: Questionnaire;
    onAnimationEnd: () => void 
}) => {
    return (
        <>
            <QuestionnaireMetaInfo questionnaire={questionnaire} />

            <div className='module-questionnaire-title'>
                <h2 className='title'>{questionnaire.name}</h2>
                <RichTextView model={questionnaire.content} />
            </div>

            <QuestionResults
                items={questionnaire.items}
                onClickAnswerDetail={onClickAnswerDetail}
                onAnimationEnd={onAnimationEnd}
            />
        </>
    );
};

export default ListView;
